module.exports = __webpack_public_path__ + "img/arm-header-icons-hover-02.d972ee34.svg";